import { BaseComponent } from '../core/BaseComponent.js';

/**
 * MobileMenu - Handles mobile menu toggle functionality
 */
export class MobileMenu extends BaseComponent {
    constructor(options = {}) {
        super(document, options);
        
        this.menuSelector = options.menuSelector || 'div#header';
        this.overlaySelector = options.overlaySelector || '.mobile_menu_overlay';
        this.toggleSelector = options.toggleSelector || '.mobile_menu_btn';
    }

    init() {
        this.cacheElements();
        this.setupEventListeners();
        
        return this;
    }

    cacheElements() {
        this.menu = document.querySelector(this.menuSelector);
        this.overlay = document.querySelector(this.overlaySelector);
        this.toggleButtons = document.querySelectorAll(this.toggleSelector);
    }

    setupEventListeners() {
        // Toggle buttons
        this.toggleButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle();
            });
        });

        // Overlay click to close
        if (this.overlay) {
            this.overlay.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        // Close on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
                this.close();
            }
        });
    }

    toggle() {
        if (this.isOpen()) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (this.menu) {
            this.menu.classList.add('active');
        }
        if (this.overlay) {
            this.overlay.classList.add('active');
        }
        document.body.style.overflow = 'hidden';
    }

    close() {
        if (this.menu) {
            this.menu.classList.remove('active');
        }
        if (this.overlay) {
            this.overlay.classList.remove('active');
        }
        document.body.style.overflow = '';
    }

    isOpen() {
        return this.menu?.classList.contains('active');
    }
}

